import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("详情")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_page = _resolveComponent("page")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.table,
        stripe: "",
        "empty-text": "没有记录",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            align: "center",
            type: "index",
            label: "序号",
            width: "50"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "caseNo",
            label: "案号"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "court",
            label: "法院名称"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "punishDate",
            label: "立案日期"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.toDate(scope.row.punishDate,'YYYY-MM-DD')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "prosecutorList",
            label: "公诉人/原告/上诉人/申请人"
          }, {
            default: _withCtx((scope) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.prosecutorList, (item, index) => {
                return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(index?'、':'') + _toDisplayString(item.name), 1))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "defendantList",
            label: "被告人/被告/被上诉人/被申请人"
          }, {
            default: _withCtx((scope) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.defendantList, (item, index) => {
                return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(index?'、':'') + _toDisplayString(item.name), 1))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            label: "操作"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                onClick: ($event: any) => (_ctx.ckInfo(scope.row)),
                type: "text"
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_page, {
      currentPage: _ctx.pageIndex,
      pageSize: _ctx.pageSize,
      pages: _ctx.pageCount,
      onChangePage: _ctx.changePage
    }, null, 8, ["currentPage", "pageSize", "pages", "onChangePage"])
  ], 64))
}